import * as React from 'react';

const SvgIconTrendsetter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M23.25 15a6 6 0 01-6 6h-1.782a1.9 1.9 0 01-1.652-.974L12.7 16.237a.749.749 0 00-1.4 0l-1.115 3.789A1.902 1.902 0 018.532 21H6.75a6 6 0 01-6-6v-1.5a3 3 0 013-3h16.5a3 3 0 013 3V15z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66 11.349l2.96-6.987A2.348 2.348 0 016.75 3 2.25 2.25 0 019 5.25M22.339 11.349l-2.96-6.987A2.348 2.348 0 0017.25 3 2.25 2.25 0 0015 5.25"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTrendsetter;
